import { CSSObject } from '@chakra-ui/react';
import background from '@/assets/betroyale/images/backgrounds/desktopBg.png';
import backgroundAtRetina from '@/assets/betroyale/images/backgrounds/desktopBgAtRetina.png';
import backgroundMobile from '@/assets/betroyale/images/backgrounds/mobileBg.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: [null, null, 'center'],
  minH: '100dvh',
  minW: '100dvw',
  bgImage: `url(${background})`,
  bgRepeat: 'no-repeat',
  bgPosition: 'center',
  lineHeight: '4',

  '@media (max-width: 480px)': {
    bgImage: `url(${backgroundMobile})`,
    bgSize: '125% 125%',
  },

  '@media (-webkit-min-device-pixel-ratio: 2)': {
    bgImage: `url(${backgroundAtRetina})`,
  },
};

export const CenterWrapper: CSSObject = {
  bg: 'transparent',
  borderRadius: [null, null, 'xl'],
  color: 'white',
  flex: ['1', null, '0'],
  gap: '0',
  justifyContent: 'center',
  mt: ['0', null, '12'],
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  maxW: 'container.md',
  px: ['4', null, '28'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
};

export const ContentHeadingText: CSSObject = {
  fontFamily: 'Spectral',
  fontSize: ['4xl', null, '5xl'],
  lineHeight: '1',
  mt: ['6', null, '4'],
  mb: ['2.5', null, '4'],
  fontWeight: 'semibold',
  textTransform: 'uppercase',
  color: 'beta.500',
  w: ['386px', null, '750px'],
};

export const ContentBodyText: CSSObject = {
  fontSize: ['md', 'lg'],
  lineHeight: 'tall',
  textAlign: 'center',
  filter: 'drop-shadow(0px 5px 5px rgba(0,0,0,.5))',

  b: {
    display: 'block',
    fontSize: 'md',
    lineHeight: 'base',
    mb: '4',
  },

  '.chakra-link': {
    fontSize: ['2xs', 'xs'],
    fontWeight: 'bold',
  },
};

export const ContactText: CSSObject = {
  '&&': {
    fontSize: ['sm', null, 'lg'],
  },
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  fontSize: ['sm', null, 'lg'],
  mt: '4',
};

export const TextHeadingColor: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, gamma.500)',
  bgClip: 'text',
  textShadow: 'none',
  display: 'flex',
};

export const RegistrationContent: CSSObject = {
  fontSize: ['xs', null],
  w: [null, null, '591px'],
  '.chakra-link': {
    fontSize: ['xs', null],
    fontWeight: 'bold',
  },
};
